import { render, staticRenderFns } from "./brand_multiselect.vue?vue&type=template&id=08a41b77&scoped=true"
import script from "./brand_multiselect.vue?vue&type=script&lang=js"
export * from "./brand_multiselect.vue?vue&type=script&lang=js"
import style0 from "./brand_multiselect.vue?vue&type=style&index=0&id=08a41b77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a41b77",
  null
  
)

export default component.exports